module.exports = {
    STEP: 'step',
    OK: 'ok',
    KO: 'ko'
}